const SCRIPT_ID = 'hotelpayScript';

const SCRIPT_URL = 'https://js.hotelpay.net/v2/sdk/hotelpay.umd.js';

export { SCRIPT_ID, SCRIPT_URL };
